export enum DeliveryTermsEnum {
    DDUDELIVERYDUTYU = 'DDU-DELIVERY DUTY U',
    DODDOORDELIVERY = 'DOD-DOOR DELIVERY',
    CICOSTINSURANC = 'C&I-COST & INSURANC',
    CFCOSTFREIGHT = 'C&F-COST & FREIGHT',
    CFRCOSTFREIGHT = 'CFR-COST & FREIGHT',
    CIFCOSTINFREIGHT = 'CIF-COST IN FREIGHT',
    CIPCRGINSPAIDTO = 'CIP-CRG INS PAID TO',
    CODCASHONDELY = 'COD-CASH ON DELY',
    COUCOURIER= 'COU-COURIER',
    CPACPTAIR = 'CPA-CPT AIR',
    CPTCARIAGEPAIDTO = 'CPT-CARIAGE PAID TO',
    DAPDELIVRDATPLC = 'DAP-DELIVRD AT PLC',
    FOBFREEONBOARD = 'FOB-FREE ON BOARD',
    DDPDLVRDDUTYPAID = 'DDP-DLVRD DUTY PAID', 
    EXCEXCONSOLIDATOR ='EXC-EX-CONSOLIDATOR',
    EXGEXGODOWNSEXGEXGODOWNS = 'EXG-EX-GODOWNS EXG-EX-GODOWNS',
    EXWEXWORKSEXWEXWORKS = 'EXW-EX-WORKS   EXW-EX-WORKS',
    FCAFREECARRIER ='FCA-FREE CARRIER',
    FOCFREEOFCOST  = 'FOC-FREE OF COST',
    SCOSELFCOLLECT = 'SCO-SELF COLLECT',
    NANA  = 'NA-N/A',
    FORFREEONROAD  = 'FOR-FREE ON ROAD',
    INCNotApplicable='INC-Not Applicable',
    LDPLANDEDDUTYPD = 'LDP-LANDED DUTY PD',
    FOB = 'FOB',
    FOC = 'FOC',
}
